var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTable',{attrs:{"title":_vm.title,"routeKey":_vm.routeKey,"routes":_vm.routes,"table":_vm.table,"items":_vm.items,"meta":_vm.meta,"sort":_vm.sort,"page":_vm.page,"onDelete":_vm.onDelete,"toggleSort":_vm.toggleSort,"changePage":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }